export const GeoCodeConstants = {
    GET_GEOCODE: 'GET_GEOCODE',

    GET_GEOCODE_REQUEST: 'GET_GEOCODE_REQUEST',
    GET_GEOCODE_SUCCESS: 'GET_GEOCODE_SUCCESS',
    GET_GEOCODE_FAILURE: 'GET_GEOCODE_FAILURE'
};
